import seller from './seller'

export default seller
